import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ItemCard } from '../../../components/atoms/ItemCard';
import { ItemCardField } from '../../../components/atoms/ItemCardField';
import { TypePill } from '../../../components/atoms/TypePill';
import { CloneEntityButton } from '../../../components/molecules/CloneEntityButton';
import { getLocalDate } from '../../../config/utils/dateHelpers';
import { CURRENCY } from '../../../interfaces/enumerables';
import {
  MONEY_COLLECTION_TRADER_TYPE_LABEL,
  MoneyCollectionInList,
} from '../../../interfaces/moneyCollection.interface';
import { PATHS } from '../../../navigation/data';

interface Props {
  index: number;
  data: MoneyCollectionInList;
}

export const MoneyCollectionItemCard = ({ index, data }: Props) => {
  const { t } = useTranslation();
  const currencySymbol = useMemo(
    () => CURRENCY[data?.customer?.currency?.currencyCode || 'EUR'] || CURRENCY.EUR,
    [data?.customer?.currency?.currencyCode],
  );

  const getDate = useCallback(() => {
    return getLocalDate(data?.date);
  }, [data]);

  return (
    <div className="width-100 itemOfList positionRelative" data-testid={`item_${index}`}>
      <ItemCard routerLink={`${PATHS.MONEY_COLLECTION}/view/${data.id}`} entityId={data.serialNumber} index={index}>
        <>
          <TypePill type={t(`MONEY_COLLECTION_PAYMENT_TYPES.${data?.paymentType}`)} />
          <TypePill
            type={t(`MONEY_COLLECTION.${MONEY_COLLECTION_TRADER_TYPE_LABEL[data?.traderType || 1]}`)}
            top={24}
          />
          <div className="flex-space-between-center-row-wrap width-100">
            <ItemCardField classes="margin-r-24" width="width-180px" value={data?.customer?.companyName || ''} />
            <ItemCardField classes="margin-r-24" width="width-180px" value={`${data?.value} ${currencySymbol}`} />
            <ItemCardField classes="margin-r-24" width="width-180px" value={getDate()} />
          </div>
        </>
      </ItemCard>
      <CloneEntityButton index={index} data={{ id: data.id }} path={PATHS.CLONE_MONEY_COLLECTION} />
    </div>
  );
};
